import { useMutation } from "react-query"
import api from "../client"
import { CreateUserPayload, GetUserResponseData } from "../types/user"

const postData = async (payload: CreateUserPayload) => {
    const { data } = await api.post<GetUserResponseData>(
        `/users`,
        payload
    )
    return data
}

export const useCreateUser = () => {
    return useMutation((payload: CreateUserPayload) => {
        return postData(payload)
    })
}
